<template>
    <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
        <ion-card v-if="show" mode="ios" style="margin: 0 0 20px 0px" :disabled="status.class === 'danger'">
            <ion-item>
                <ion-label mode="md" class="ion-text-wrap">
                    <ion-badge>
                        <svg v-if="status.class === 'success'" class="icon icon-checkmark"><use xlink:href="#icon-checkmark"></use></svg>
                        <span>{{ status.label }}</span>
                    </ion-badge>
                    <h2 style="margin-top:5px">{{ academy_name }}</h2>
                    <p>Miasto: <strong>{{ city }}</strong></p>
                    <p>Data: <strong>{{ date_meeting }}</strong></p>
                </ion-label>
            </ion-item>
            <ion-card-content style="text-align: right">
                <ion-button mode="ios" fill="outline" size="small" @click="cancel" :disabled="status.class === 'danger'">Anuluj zgłoszenie</ion-button>
            </ion-card-content>
        </ion-card>
    </slide-x-left-transition>
</template>

<script>
    import api from '@/services/Api';

    export default {
        name: 'ItemUserAcademy',
        props: ['index', 'hash', 'academy_name', 'city', 'date_meeting', 'status'],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        },
        methods: {
            cancel(e){
                e.preventDefault();
                this.$ionic.alertController
                    .create({
                        header: 'Potwierdź',
                        message: 'Czy na pewno chcesz zrezygować z tej akademii?',
                        buttons: [
                            {
                                text: 'Anuluj',
                                role: 'cancel',
                                handler: () => {
                                    /* *** */
//                                    this.$ga.event('user', 'logout cancel')
                                },
                            },
                            {
                                text: 'Tak',
                                handler: () => {
                                    return this.postCancelUserAcademy();
                                }
                            }
                        ],
                        mode: 'md'
                    })
                    .then(a => a.present())
            },
            postCancelUserAcademy() {
                let url = 'users/academies/applications/'+this.hash+'/registration/cancel';
                api({url: url, method: 'GET'})
                    .then(resp => {
                        this.$store.dispatch('GLOBAL_TOAST','Wypisaliśmy Cię poprawnie.');

                        // todo refactor to vuex
                        let index = this.$parent.academies.map(function (item) {
                            return item.hash
                        }).indexOf(this.hash);
                        // todo get status from api response!
                        let newStatus = {
                            'class' : "danger",
                            'label' : "zrezygnowano"
                        }
                        this.$parent.academies[index].status = newStatus

                    });
            },
        }
    }
</script>

<style lang="scss" scoped>
    ion-card-content{
        padding: 8px 12px;
    }
    .badge-gray{
        background: #d2d2d2;
    }
</style>